module.exports = __webpack_public_path__ + "img/food.30d479fc.png";